export default {
  REMOVE: 'REMOVE_CONVERSATION',
  REQUESTING: 'LOADING_ACTIVE_CONVERSATION',
  ERROR: 'ACTIVE_CONVERSATION_ERROR',
  RECEIVE_MESSAGE: 'RECEIVE_MESSAGE'
};
